const yup = require("yup");

const approvals = yup.object().shape({
  userRole: yup.string().required("User role is required"),
  administratorApprovalOnly: yup.boolean(),
  managerApprovalOnly: yup.boolean(),
  managerAndAdministrators: yup.boolean(),
  workflowSettings: yup
    .string()
    .when(
      [
        "administratorApprovalOnly",
        "managerApprovalOnly",
        "managerAndAdministrators",
      ],
      {
        is: (
          administratorApprovalOnly,
          managerApprovalOnly,
          managerAndAdministrators,
        ) => {
          return (
            !administratorApprovalOnly &&
            !managerApprovalOnly &&
            !managerAndAdministrators
          );
        },
        then: (schema) => schema.required("One option is required"),
      },
    ),
});

export default approvals;
